// @flow

import WarningBlock from './WarningBlock'

export default WarningBlock
